var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system footer-margin do-not-translate"},[_c('div',{staticClass:"container footer-margin",domProps:{"innerHTML":_vm._s(_vm.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }